module.exports = __webpack_public_path__ + "static/media/flame.87f36453.svg";